"use client";

import type { ReactNode } from "react";
import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface FoldProps {
  title: string;
  /** Shown on the closed header, so the section reports itself without opening. */
  state: string;
  defaultOpen?: boolean;
  children: ReactNode;
}

/**
 * Settings that are set once and rarely revisited collapse to a single line,
 * while still saying what they are currently set to.
 */
export function Fold({ title, state, defaultOpen = false, children }: FoldProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="rounded-lg border">
      <button
        type="button"
        aria-expanded={open}
        className="flex w-full items-center gap-2.5 rounded-lg px-3.5 py-2.5 text-left hover:bg-muted/40"
        onClick={() => setOpen((v) => !v)}
      >
        <ChevronRight
          className={cn(
            "h-[15px] w-[15px] text-muted-foreground transition-transform",
            open && "rotate-90",
          )}
        />
        <span className="text-[13.5px] font-semibold">{title}</span>
        <span className="ml-auto text-xs text-muted-foreground">{state}</span>
      </button>
      {open && <div className="px-3.5 pb-4 pt-0.5">{children}</div>}
    </div>
  );
}
